import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { getDashboardData } from '../../services/dashboard';

// --- Estilos Compartidos ---
import { PageWrapper, MainGrid, BottomGrid, LoadingOverlay, Spinner } from './components/DashboardStyles';

// --- Sub-componentes ---
import FilterBar from './components/FilterBar';
import KpiSection from './components/KpiSection';
import GrowthChartCard from './components/GrowthChartCard';
import MembershipMixCard from './components/MembershipMixCard';
import RolesDistributionCard from './components/RolesDistributionCard';
import UserDemographicsCard from './components/UserDemographicsCard';
import ConversionFunnelCard from './components/ConversionFunnelCard';
import ActionButtons from './components/ActionButtons';

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    zones: [], // Vacío = Todo México
    startDate: dayjs().subtract(30, 'days').startOf('day').toISOString(),
    endDate: dayjs().endOf('day').toISOString(),
    userType: 'ALL'
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getDashboardData(filters);
        setData(result);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters]);

  if (loading && !data) {
    return (
      <PageWrapper>
        <div style={{ padding: '20px', color: '#fff' }}>Cargando dashboard...</div>
      </PageWrapper>
    );
  }

  if (!data) {
    return (
      <PageWrapper>
        <div style={{ padding: '20px', color: '#fff' }}>No se pudieron cargar los datos del dashboard.</div>
      </PageWrapper>
    );
  }

  const {
    growthData,
    rolesData,
    ageData,
    categoriesData,
    funnelData,
    membershipData,
    mexicoHeatmapData,
    kpis,
    regions
  } = data;

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  return (
    <PageWrapper>
      {loading && (
        <LoadingOverlay>
          <Spinner />
        </LoadingOverlay>
      )}
      {/* --- Barra de Filtros --- */}
      <FilterBar
        regions={regions}
        filters={filters}
        onFilterChange={handleFilterChange}
      />

      {/* --- Sección de KPIs --- */}
      <KpiSection kpis={kpis} />

      {/* --- Fila principal: Crecimiento + Mix de Membresías --- */}
      <MainGrid>
        <GrowthChartCard data={growthData} />
        <MembershipMixCard
          membershipData={membershipData}
          mexicoHeatmapData={mexicoHeatmapData}
        />
      </MainGrid>

      {/* --- Fila inferior: Roles + Mapa Activos + Funnel --- */}
      <BottomGrid>
        <RolesDistributionCard data={rolesData} />
        <UserDemographicsCard
          ageData={ageData}
          categoriesData={categoriesData} // Se va a segmentar por categorias de membresias
        />
        <ConversionFunnelCard data={funnelData} />
      </BottomGrid>

      {/* --- Botones de acción --- */}
      <ActionButtons filters={filters} />
    </PageWrapper>
  );
};

export default Dashboard;

